import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { MicrolinkBaseClass } from "../../helpers/microlink";

var DeviantArt = /*#__PURE__*/function (_MicrolinkBaseClass) {
  _inherits(DeviantArt, _MicrolinkBaseClass);

  var _super = _createSuper(DeviantArt);

  function DeviantArt() {
    var _this;

    _classCallCheck(this, DeviantArt);

    _this = _super.apply(this, arguments);
    _this.name = "deviantart";
    _this.icon = "<svg aria-hidden=\"true\" viewbox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#000\" fill-rule=\"nonzero\" d=\"M208 44V0h-49l-2 5-22 35-7 9H49v66h44l5 5-49 89v47h49l2-5 24-42 4-6h80v-62h-44l-5-4z\"/></svg>";
    _this.color = "#00d159";
    _this.exampleURL = "https://www.deviantart.com/artbycatherineradley/art/Despair-820869682";

    _this.validator = function (input) {
      return /(https?:\/\/(.+?\.)?(deviantart|fav)\.(com|me)(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/.test(input);
    };

    return _this;
  }

  return DeviantArt;
}(MicrolinkBaseClass);

export { DeviantArt as default };